import styled from 'styled-components';

export const LoaderWrapper = styled.div`
    width: 100%;
    margin: 0 auto;
`;
